module.exports = __webpack_public_path__ + "media/components/assets/img/pic/hut-0b628acf9fbacf42aa16de323fe67937.svg";